import ModalBase, { ModalType } from "../modals/ModalBase";
import SubregionMap from "../../assets/images/Subregion-map.png";
import { uiIcons } from "../../assets/icons";
import styled from "@emotion/styled";
import { NavModalTrigger } from "@atlas-int/ui";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";

const SubregionMapImage = styled.img`
  width: 100%;
  height: 100%;
`;

const SubregionMapModalButton = ({
  menuOptionClassName,
  isNavigationBarOpen,
}: any) => {
  return (
    <NavModalTrigger
      icon={uiIcons.subregionMap}
      iconAlt="Subregion Map"
      label="Subregion Map"
      isNavOpen={isNavigationBarOpen}
      menuOptionClassName={menuOptionClassName}
      onOpen={() =>
        googleAnalyticsCustomEvent("leftnav", "click", "regionmap", "explore")
      }
    >
      {({ isOpen, onToggle }) =>
        isOpen ? (
          <ModalBase
            modalType={ModalType.SubregionMap}
            toggleModal={onToggle}
          >
            <p>
              The Atlas contains trade data for 250 countries which are aggregated
              into regional and continental groups. Atlas regions are a modified
              version of the{" "}
              <a href="https://unstats.un.org/unsd/methodology/m49" target="_blank">
                UN Statistical Division
              </a>{" "}
              geographic regions.
            </p>
            <SubregionMapImage src={SubregionMap} />
          </ModalBase>
        ) : null
      }
    </NavModalTrigger>
  );
};

export default SubregionMapModalButton;
